module.exports = __webpack_public_path__ + "img/ZI.ba36d37f.png";